import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import ContentWMax from '../../Components/PageLayout/ContentWMax';
import PageTitle from '../../Components/PageTitle/PageTitle';
import LoadingOverlay from '../../Components/Loading/LoadingOverlay';
import api from '../../services/api';
import styles from './NotificationsPage.module.scss';

export default function NotificationsPage() {
    const navigate = useNavigate();
    const [scope, setScope] = useState('unread');
    const [loading, setLoading] = useState(false);
    const [groups, setGroups] = useState([]);
    const [unreadCount, setUnreadCount] = useState(0);

    const fetchNotifications = async ({ silent = false } = {}) => {
        try {
            if (!silent) {
                setLoading(true);
            }

            const response = await api.get(`/api/notifications?scope=${scope}`);
            setGroups(Array.isArray(response.data?.groups) ? response.data.groups : []);
            setUnreadCount(Number(response.data?.unreadCount || 0));
        } catch (error) {
            console.error('Не удалось загрузить уведомления:', error);
            setGroups([]);
            setUnreadCount(0);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let intervalId = null;
        void fetchNotifications();

        intervalId = setInterval(() => {
            if (document.visibilityState === 'visible') {
                void fetchNotifications({ silent: true });
            }
        }, 10000);

        return () => {
            if (intervalId) {
                clearInterval(intervalId);
            }
        };
    }, [scope]);

    const handleOpenTask = async (taskId) => {
        try {
            await api.post('/api/notifications/mark-read', { taskId });
        } catch (error) {
            console.error('Не удалось отметить уведомления прочитанными:', error);
        }

        navigate(`/task/${taskId}`);
    };

    const handleMarkAllRead = async () => {
        try {
            await api.post('/api/notifications/mark-read', { all: true });
            await fetchNotifications({ silent: true });
        } catch (error) {
            console.error('Не удалось отметить все уведомления прочитанными:', error);
        }
    };

    return (
        <ContentWMax>
            <PageTitle title="Уведомления" />

            <div className={styles.page}>
                {loading ? <LoadingOverlay text="Загружаем уведомления..." /> : null}

                <div className={styles.toolbar}>
                    <div className={styles.scopeTabs}>
                        <button
                            type="button"
                            className={scope === 'unread' ? styles.tabActive : styles.tab}
                            onClick={() => setScope('unread')}
                        >
                            Непрочитанные
                        </button>
                        <button
                            type="button"
                            className={scope === 'all' ? styles.tabActive : styles.tab}
                            onClick={() => setScope('all')}
                        >
                            Все
                        </button>
                    </div>

                    <div className={styles.toolbarActions}>
                        <span className={styles.counter}>Непрочитанных: {unreadCount}</span>
                        <button type="button" className={styles.secondaryBtn} onClick={() => fetchNotifications()}>
                            Обновить
                        </button>
                        <button type="button" className={styles.primaryBtn} onClick={handleMarkAllRead}>
                            Прочитать все
                        </button>
                    </div>
                </div>

                <div className={styles.groupList}>
                    {groups.length === 0 ? (
                        <div className={styles.emptyState}>Уведомлений пока нет.</div>
                    ) : groups.map((group) => (
                        <button
                            key={group.taskId}
                            type="button"
                            className={styles.groupCard}
                            onClick={() => handleOpenTask(group.taskId)}
                        >
                            <div className={styles.groupHeader}>
                                <strong>#{group.taskId} {group.taskTitle || 'Без названия'}</strong>
                                <span>{group.lastCreatedAt || '—'}</span>
                            </div>

                            <div className={styles.groupMeta}>
                                <span>Статус: {group.taskStatus || '—'}</span>
                                <span>Непрочитанных: {group.unreadCount || 0}</span>
                            </div>

                            {Array.isArray(group.actors) && group.actors.length > 0 ? (
                                <div className={styles.actors}>Упоминали: {group.actors.join(', ')}</div>
                            ) : null}

                            {group.lastPreview ? <div className={styles.preview}>{group.lastPreview}</div> : null}
                        </button>
                    ))}
                </div>
            </div>
        </ContentWMax>
    );
}
